import { KeyboardEvent, MouseEvent, useCallback, useRef, useState } from "react"
import Actionbar from "src/components/common/actionbar/Authactionbar"
import { Message } from "src/components/common/form/Message"
import { useInitUserSearchFilter } from "src/hooks/useInitUserSearchFilter"
import useUiuxStore from "src/store/useUiuxStore"
import { InsertRowHandler } from "src/utils/grid/GridHandlerContent"


import { AgGridReact } from "ag-grid-react"
import { Content_KSK2030_R01 } from "./Content_KSK2030_R01"
import { defaultKSK2030_R01Dto, KSK2030_R01DetailDto, KSK2030_R01Dto } from "./Dto_KSK2030_R01"
import { SearchSection_KSK2030_R01 } from "./SearchSection_KSK2030_R01"
import { useKSK2030_R01Store } from "./Store_KSK2030_R01"
import { Table_KSK2030_R01 } from "./Table_KSK2030_R01"
import { Modal_KSK2030_R01 } from "./Modal_KSK2030_R01"
import { DetailTable_KSK2030_R01 } from "./DetailTable_KSK2030_R01"

/**
 * 사용자 관리 컨테이너 컴포넌트
 * 사용자 관리 화면의 전체 레이아웃과 상태 관리를 담당
 */
export const Container_KSK2030_R01 = () => {
	const { 
		KSK2030_R01List,
		insertKSK2030_R01List,
		modalVisible,
		initData,
		KSK2030_R01Filter,
		setKSK2030_R01Filter,
	} = useKSK2030_R01Store();
	const { setMessage } = useUiuxStore();
	useInitUserSearchFilter(setKSK2030_R01Filter, KSK2030_R01Filter);
	
	const gridRef = useRef<AgGridReact<KSK2030_R01Dto> | null>(null);
	const detailGridRef = useRef<AgGridReact<KSK2030_R01DetailDto> | null>(null);
	

	const {
		handleExcelClick,
		fetchData,
		fetchOne,
		defaultKSK2030_R01Row,
		handleSaveClick,
		handleDeleteClick,
		fetchDetailList,
	} = Content_KSK2030_R01({
		gridRef,
		setMessage,
		
	});

    const [clickable, setClickable] = useState(true);

	// 상단 '등록' 버튼 전용 핸들러
	const handleInsertClick = useCallback((e: MouseEvent<HTMLButtonElement>) => {
		InsertRowHandler({
			event: e,
			dataList: KSK2030_R01List,
			rowData: {...defaultKSK2030_R01Row, valueIndex: -1},
			insertRow: insertKSK2030_R01List,
			defaultRowData: defaultKSK2030_R01Row,
			setClickable
		});
	}, [KSK2030_R01List, insertKSK2030_R01List, setClickable]);

	return <div className="content-container">
		
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleInsertClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onExcelClick={handleExcelClick}
			onInitClick={initData}
		/>
		
		<SearchSection_KSK2030_R01 />
		<div className="flex-1 flex-col gap-[6px]">
			<div className="w-full h-[50%] flex flex-col  p-[12px] gap-[12px]">
				
				<Table_KSK2030_R01
					clickable={clickable}				setClickable={setClickable}
					gridRef={gridRef}
					fetchOne={fetchOne}
					fetchDetailList={fetchDetailList}
				/>
			</div>
			<div className="w-full h-[50%] flex flex-col  p-[12px] gap-[12px]">	
				<DetailTable_KSK2030_R01
					clickable={clickable}				setClickable={setClickable}
					gridRef={detailGridRef}
				/>
			</div>
		</div>
		{modalVisible && <Modal_KSK2030_R01 handleSaveClick={handleSaveClick} />}
	</div>
}
